import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'

import {
    pessoaDao,
    fisioterapeutaDao,
    pacienteDao,
    atendimentoDao,
    avaliacaoDao,
    sendzapiDao,
    administradorDao,
    notificacoesDao
} from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        headers: {},
        user: null,
        loading: false,
        pacientes: [],
        atendimentos: [],
        avaliacoes: [],
        fisioterapeutas: [],
        fisioterapeuta: null,
        smartlock: null,
        authenticated: null,
        interval: null,
        error: null,
    },
    mutations: {
        setAuthHeader (state, payload) {
            state.headers = new Headers({
                'Content-Type': 'application/json',
                Authorization: `Bearer ${payload}`
            })
        },
        setUser(state, user) {
            state.user = user
        },
        setPacientes(state, payload) {
            state.pacientes = payload
        },
        setFisioterapeutas(state, payload) {
            state.fisioterapeutas = payload
        },
        setAtendimentos(state, payload) {
            state.atendimentos = payload
        },
        setAvaliacoes(state, payload) {
            state.avaliacoes = payload
        },
        setFisioterapeuta(state, payload) {
            state.fisioterapeuta = payload
        },
        setLoading (state, payload) {
            state.loading = payload
        },
        setError (state, payload) {
            state.error = payload
        },
        setSuccess (state, payload) {
            state.success = payload
        },
        setSmartlock (state, payload) {
            state.smartlock = payload
        },
        setAuthenticated (state, payload) {
            state.authenticated = payload
        },
        clearTimer(state) {
            if (state.interval) {
                clearInterval(state.interval)
                state.interval = null
            }
        }
    },
    actions: {
        signUserIn({ commit, dispatch }, payload) {
            commit('setLoading', true)
            firebase
                .auth()
                .signInWithEmailAndPassword(payload.email, payload.password)
                .then(async (userCredential) => {
                    const user = userCredential.user
                    const token = await user.getIdToken()
                    // Verifica se é admin antes de prosseguir
                    administradorDao.verificarAdmin(
                        new Headers({
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`
                        }),
                        user.email
                    ).then((response) => {
                        if (!response.ok) {
                            // Não é admin, faz logout e mostra erro
                            firebase.auth().signOut()
                            commit('setLoading', false)
                            commit('setError', { message: 'Acesso negado.' })
                        } else {
                            // É admin, segue login
                            commit('setUser', user)
                            commit('setAuthHeader', token)
                            commit('setLoading', false)
                            commit('setError', null)
                            dispatch('renovarToken')
                            commit('setAuthenticated', true)
                        }
                    })
                })
                .catch(() => {
                    commit('setLoading', false)
                    commit('setError', { message: 'Email ou senha inválidos.' })
                })
        },
        signUserOut ({ commit }) {
            commit('setLoading', true)
            return firebase
                .auth()
                .signOut()
                .catch((error) => {
                    var errorCode = error.code
                    var errorMessage = error.message
                    console.log(errorCode)
                    console.log(errorMessage)
                })
                .finally(() => {
                    commit('clearTimer')
                    commit('setUser', null)
                    commit('setAuthHeader', null)
                    commit('setAuthenticated', false)
                    commit('setLoading', false)
                })
        },
        autenticarLogin ({ commit }) {
            commit('setAuthenticated', true)
        },
        verificarAdministrador ({ commit, state }, payload) {
            return new Promise(() => {
                administradorDao.verificarAdmin(state.headers).then((response) => {
                    if (!response.ok) {
                        this.dispatch('signUserOut')
                        commit('setError', {
                        message: 'Você não é um administrador'
                        })
                    } else {
                        let lastpage = localStorage.getItem(`admin-${payload.id}`)
                        if (lastpage) {
                            commit('setLastPage', lastpage)
                        }
                        commit('setUser', payload)
                        this.dispatch('renovarToken')
                    }
                })
            })
        },
        async renovarToken ({ commit, state }) {
            commit('clearTimer')
            let diference
            var expirationTime
            var issuedAtTime
            if (state.user != null) {
                await firebase
                .auth()
                .currentUser.getIdTokenResult(true)
                .then((result) => {
                    expirationTime = Date.parse(result.expirationTime)
                    issuedAtTime = Date.parse(result.issuedAtTime)
                    diference = (expirationTime - issuedAtTime) / 1000 / 2
                    diference = diference.toFixed(0)
                })
                state.interval = setInterval(() => {
                    diference--
                    if (diference === 0) {
                        firebase
                        .auth()
                        .currentUser.getIdToken(true)
                        .then((token) => {
                            commit('setAuthHeader', token)
                        })
                        firebase
                        .auth()
                        .currentUser.getIdTokenResult(true)
                        .then((result) => {
                            var expirationTime
                            var issuedAtTime
                            expirationTime = Date.parse(result.expirationTime)
                            issuedAtTime = Date.parse(result.issuedAtTime)
                            diference = (expirationTime - issuedAtTime) / 1000 / 2
                            diference = diference.toFixed(0)
                        })
                    }
                }, 1000)
            }
        },
        pegarPessoas({ commit, state }, payload) {
            return new Promise((resolve, reject) => {
                commit('setLoading', true)
                pessoaDao.pegarPessoas(state.headers, payload)
                    .then((response) => {
                        commit('setLoading', false)
                        if (response.ok) {
                            resolve(response.json())
                        }
                    })
                    .catch((error) => {
                        commit('setLoading', false)
                        reject(error)
                    })
            })
        },
        pegarAvaliacoes({ commit, state }, payload) {
            return new Promise((resolve, reject) => {
                commit('setLoading', true)
                avaliacaoDao.listarAvaliacoes(state.headers, payload)
                    .then((response) => {
                        commit('setLoading', false)
                        if (response.ok) {
                            resolve(response.json())
                        }
                    })
                    .catch((error) => {
                        commit('setLoading', false)
                        reject(error)
                    })
            })
        },
        pegarRelatorios({ commit, state }, payload){
            return new Promise((resolve, reject) => {
                commit('setLoading', true)
                administradorDao.PegarRelatorio(state.headers, payload)
                .then((response) =>{
                    commit('setLoading', false)
                    if(response.ok){
                        resolve(response.json())
                    }
                })
                .catch((error) => {
                    commit('setLoading', false)
                    reject(error)
                })
            })
        },
        pegarAtendimentos({ commit, state }, payload) {
            return new Promise((resolve, reject) => {
                commit('setLoading', true)
                atendimentoDao.pegarAtendimentos(state.headers, payload)
                .then((response) => {
                    commit('setLoading', false)
                    if (response.ok) {
                        resolve(response.json())
                    }
                })
                .catch((error) => {
                    commit('setLoading', false)
                    reject(error)
                })
            })
        },
       cadastrarEspecialidade({ commit, state }, nome) {
            return new Promise((resolve, reject) => {
                commit('setLoading', true)
                administradorDao.cadastrarEspecialidade(nome, state.headers)
                    .then((response) => {
                        commit('setLoading', false)
                        if (!response.ok) {
                            response.json()
                                .then(err => {
                                    commit('setError', err)
                                    reject(err)
                                })
                                .catch(() => {
                                    const err = { message: 'Não foi possível cadastrar especialidade' }
                                    commit('setError', err)
                                    reject(err)
                                })
                        } else {
                            response.json()
                                .then(data => {
                                    commit('setSuccess', 'Especialidade cadastrada')
                                    resolve(data)
                                })
                                .catch(() => {
                                    commit('setSuccess', 'Especialidade cadastrada')
                                    resolve('ok')
                                })
                        }
                    })
                    .catch((error) => {
                        commit('setLoading', false)
                        commit('setError', error.message || 'Erro na requisição')
                        reject(error)
                    })
            })
        },
        listarEspecialidades({ commit, state }) {
            return new Promise((resolve, reject) => {
                commit('setLoading', true)
                administradorDao.listarEspecialidades(state.headers)
                    .then((response) => {
                        commit('setLoading', false)
                        if (response.ok) {
                            resolve(response.json())
                        }
                    })
                    .catch((error) => {
                        commit('setLoading', false)
                        commit('setError', error.message || 'Erro na requisição')
                        reject(error)
                    })
            })
        },
        cadastrarAdministrador({ commit, state }, email) {
            return new Promise((resolve, reject) => {
                commit('setLoading', true)
                administradorDao.cadastrarAdministrador(email, state.headers)
                    .then((response) => {
                        commit('setLoading', false)
                        if (!response.ok) {
                            response.json()
                                .then(err => {
                                    commit('setError', err)
                                    reject(err)
                                })
                                .catch(() => {
                                    const err = { message: 'Não foi possível cadastrar administrador' }
                                    commit('setError', err)
                                    reject(err)
                                })
                        } else {
                            response.json()
                                .then(data => {
                                    commit('setSuccess', 'Administrador cadastrado')
                                    resolve(data)
                                })
                                .catch(() => {
                                    commit('setSuccess', 'Administrador cadastrado')
                                    resolve('ok')
                                })
                        }
                    })
                    .catch((error) => {
                        commit('setLoading', false)
                        commit('setError', error.message || 'Erro na requisição')
                        reject(error)
                    })
            })
        },
        listarAdministradores({ commit, state }) {
            return new Promise((resolve, reject) => {
                commit('setLoading', true)
                administradorDao.listarAdministradores(state.headers)
                    .then((response) => {
                        commit('setLoading', false)
                        if (response.ok) {
                            resolve(response.json())
                        }
                    })
                    .catch((error) => {
                        commit('setLoading', false)
                        commit('setError', error.message || 'Erro na requisição')
                        reject(error)
                    })
            })
        },
        sendZapi ({ commit, state }, payload) {
            /*
                Usada para GET, DELETE, PUT
            */
            return new Promise((resolve, reject) => {
                commit('setLoading', true)
                sendzapiDao
                    .conexao(state.headers, payload)
                    .then((response) => {
                        commit('setLoading', false)
                        if (!response.ok) {
                            if (payload.method === 'GET') reject(new Error('Conexão já existente'))
                            else if (payload.method === 'PUT') {
                                commit('setError', 'Não foi possível atualizar informações')
                                reject(new Error('Não foi possível atualizar informações'))
                            } else if (payload.method === 'DELETE') {
                                commit('setError', 'Não foi possível cancelar conexão')
                                reject(new Error('Não foi possível cancelar conexão'))
                            }
                        }
                        if (payload.method === 'GET') resolve(response.json())
                        else {
                            if (payload.method === 'DELETE') commit('setSuccess', 'A conexão existente foi finalizada com sucesso')
                            else if (payload.method === 'PUT') commit('setSuccess', 'A conexão foi estabelecida com sucesso')
                            resolve('ok')
                        }
                    })
                    .catch((error) => {
                        commit('setLoading', false)
                        commit('setError', error.message || 'Erro na conexão')
                        reject(error)
                    })
            })
        },
        cadastrarSmartlock ({ state }, pin) {
            return new Promise((resolve, reject) => {
                administradorDao.cadastrarSmartlock(pin, state.headers).then((response) => {
                if (!response.ok) {
                    reject(new Error('Não foi possível cadastrar'))
                } else {
                    this.dispatch('addTimer')
                    resolve('ok')
                }
                })
            })
        },
        editarPessoa ({ state }, payload) {
            return new Promise((resolve, reject) => {
                pessoaDao.editarPessoa(state.headers, payload.id_pessoa, payload.dados)
                .then((response) => {
                    if (!response.ok) {
                        reject(new Error('Não foi possível editar'))
                    } else {
                        resolve('ok')
                    }
                })
            })
        },
        pinAutenticar ({ state }, pin) {
            return administradorDao
                .autenticarpin(pin, state.headers)
                .then((response) => {
                if (!response.ok) {
                    return 'Não foi possível autenticar'
                } else {
                    this.dispatch('addTimer')
                    return 'ok'
                }
                })
                .catch((error) => {
                return error
                })
        },
        mudarStatus({ state }, payload) {
            return new Promise((resolve, reject) => {
                let promise
                if (payload.tipo === 'fisio') {
                    promise = fisioterapeutaDao.mudarStatusFisio(state.headers, payload.id)
                } else if (payload.tipo === 'paciente') {
                    promise = pacienteDao.mudarStatusPaciente(state.headers, payload.id)
                } else {
                    reject(new Error('Tipo inválido'))
                    return
                }
                promise.then(response => {
                    if (!response.ok) {
                        reject(new Error('Não foi possível mudar o status'))
                    } else {
                        resolve('ok')
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        enviarNotificacao({ commit, state }, payload) {
            return new Promise((resolve, reject) => {
                commit('setLoading', true)
                notificacoesDao.enviarNotificacao(state.headers, payload)
                    .then((response) => {
                        commit('setLoading', false)
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            reject(response.json())
                        }
                    })
                    .catch((error) => {
                        commit('setLoading', false)
                        reject(error)
                    })
            })
        },   
    },
    getters: {
        user (state) {
            return state.user
        },
        error (state) {
            return state.error
        },
        loading (state) {
            return state.loading
        },
        success (state) {
            return state.success
        },
        pacientes (state) {
            return state.pacientes
        },
        atendimentos (state) {
            return state.atendimentos
        },
        avaliacoes (state) {
            return state.avaliacoes
        },
        headers (state) {
            return state.headers
        },
        fisioterapeutas (state) {
            return state.fisioterapeutas
        },
        fisioterapeuta (state) {
            return state.fisioterapeuta
        },
        smartlock (state) {
            return state.smartlock
        }
    }
})